import React from 'react';
import { FaLocationDot } from "react-icons/fa6";

function Location() {
  return (
    <div> 
      {/* Location Section */}
      <section className="w-full mx-auto flex flex-col lg:flex-row items-center py-12 px-6 sm:px-10 lg:px-16 bg-gradient-to-r from-white to-[#dcf5de] gap-10">
        
        {/* Map */}
        <div className="w-full lg:w-[550px] h-[300px] sm:h-[400px] lg:h-[450px] rounded-3xl overflow-hidden drop-shadow-xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.224184572421!2d77.57131787582477!3d12.891926517009614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1500028c2cc5%3A0x28819707d7dba594!2sDAILY%20GO%20PVT.LTD!5e0!3m2!1sen!2sin!4v1727810020000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="border-0"
          ></iframe>
        </div>

        {/* Content */}
        <div className="flex-1 text-center lg:text-left">
          <p className="text-[#19471b] text-lg font-semibold mb-3 flex justify-center lg:justify-start items-center">
            Our Location <FaLocationDot className="ml-2" />
          </p>
          <h3 className="text-[#19471b] text-2xl sm:text-3xl font-bold mb-4">
            Connecting Near and Far
          </h3>
          <h4 className="text-base sm:text-lg font-bold mt-6 mb-2">Headquarters</h4>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                          Daily GO Pvt. Ltd, 1387, 8th Cross Rd,<br/> Om Shakthi Layout, Om Shiva Shakthi Nagar, Phase 7,<br/> J. P. Nagar, Bengaluru, Karnataka 560078

            India
          </p>
        </div>
      </section>
    </div>
  );
}

export default Location;
